import core, { App } from '@gin-betting/core';
import useWithLocation from './useWithLocation';

const {
    utils: { checkOnRoute },
} = core;

const useCheckOnRoute = (
    route: App.Routes,
    options?: { exact: boolean }
): boolean => {
    return useWithLocation(() => checkOnRoute(route, options));
};

export default useCheckOnRoute;
